<section class="content-2">
  <div class="title-container">
    <h1 class="title">Serviços, infraestrutura e recursos</h1>
    <h2 class="subtitle">Estimativa das despesas com a área administrativa, despesas de capital e outros serviços (em relação à despesa total da rede).</h2>
  </div>

  <hr class="division-line" />

  <div class="dropdown-panel panel">
    <app-menu-suspenso
      #menuTooltip="matTooltip"
      [matTooltip]="tooltipVisivel ? 'Visualizar o PQR' : ''"
      matTooltipPosition="above"
      [opcoes]="[
        {
          rotulo: 'PQR desta funcionalidade',
          icone: 'computer',
          acao: 'pqrDestaFuncionalidade'
        },
        {
          rotulo: 'Restaurar valores com base no PQR',
          icone: 'content_copy',
          acao: 'restaurarValoresComBaseNoPqr'
        },
        {
          rotulo: 'PQR completo em nova aba',
          icone: 'desktop_windows',
          acao: 'pqrCompletoEmNovaAba'
        }
      ]"
      (chamadaDeAcao)="chamarAcao($event)"
    >
      Padrão de qualidade de referência (PQR)
    </app-menu-suspenso>

    <mat-icon
      (mouseenter)="abrirTooltips()"
      (mouseleave)="fecharTooltips()"
      class="info-icon"
      #infoTooltip="matTooltip"
      matTooltip="Informações sobre o PQR"
      matTooltipPosition="left"
    >
      info
    </mat-icon>
  </div>

  <div class="panel">
    <div class="table-wrapper">
      <app-tabela
          ngSkipHydration
          class="table-component"
          [cabecalhoCustomizado]="true"
        >
          <ng-container cabecalho>
            <tr>
              <th class="table-header" style="width: 4%">
                <div class="button-wrapper">
                  <button
                    mat-icon-button
                    class="add-button"
                    (click)="adicionarDespesa()"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </th>
              <th class="table-header" style="width: 8%">
                Sequence
              </th>
              <th class="table-header">
                Item
              </th>
              <th class="table-header">
                Percentual (%)
              </th>
            </tr>
          </ng-container>
          <ng-container corpo>
            <tr *ngFor="let despesa of despesasDepartamentais; index as i">
              <td class="table-cell">
                <div class="button-wrapper">
                  <button
                    mat-icon-button
                    class="delete-button"
                    (click)="removerDespesa(i)"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </td>
              <td class="table-cell">
                <span>{{ i + 1 }}</span>
              </td>
              <td class="table-cell">
                <input
                  class="display-input align-left"
                  type="text"
                  [(ngModel)]="despesa.descricaoItem"
                  (ngModelChange)="atualizarDados()"
                />
              </td>
              <td class="table-cell">
                <input
                  class="display-input align-right text-green"
                  type="text"
                  [maskito]="mask_porcentagem_limpa"
                  [(ngModel)]="despesa.percentual"
                  (ngModelChange)="atualizarDados()"
                />
              </td>
            </tr>
          </ng-container>
          <ng-container rodape>
            <tr>
              <td class="table-cell bg-gray"></td>
              <td class="table-cell bg-gray"></td>
              <td class="table-cell bg-gray align-left bold">
                <span>Total</span>
              </td>
              <td class="table-cell bg-gray bold text-blue align-right">
                <span>{{ totalDespesasDepartamentais }}%</span>
              </td>
            </tr>
          </ng-container>
        </app-tabela>
      </div>
    </div>
</section>
